import { apiUrl } from 'config';
import UserProfile from "components/UserProfile/UserProfile";
import axios from 'axios';
import toast, { Toaster } from "react-hot-toast"

export const getPartials = async (filters = {}) => {
    const token = await UserProfile.getToken();
    const response = await axios.get(`${apiUrl}admin/partial`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        params: filters
    });
    return response.data
};

export const deletePartials = async (filters = {}) => {
    const token = await UserProfile.getToken();
    try {
        const response = await axios.delete(`${apiUrl}admin/partial`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: filters
        });
        toast.success(response.data.msg);
        return response.data
    }
    catch (error) {
        error.response.data?.msg ? toast.error(error.response.data.msg) : toast.error(error.response.data)
    }
    
}

export const modifyPartials = async (modifiedOrderPartialsDict) => {
    const token = await UserProfile.getToken();
    try {
        const response = await axios.put(
            `${apiUrl}admin/partial`,
            modifiedOrderPartialsDict,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        toast.success(response.data.msg);
    }
    catch (error) {
        error.response.data?.msg ? toast.error(error.response.data.msg) : toast.error(error.response.data)
    }
}

export const createPartial = async (newPartialDict) => {
    const token = await UserProfile.getToken();
    try {
        const response = await axios.post(
            `${apiUrl}admin/partial`,
            newPartialDict,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        toast.success(response.data.msg);
    }
    catch (error) {
        error.response.data?.msg ? toast.error(error.response.data.msg) : toast.error(error.response.data)
    }
}

// Create an axios instance with a base URL and authentication header
const api = axios.create({
    baseURL: apiUrl,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('access_token')}` // Assuming JWT auth
    }
});

export const partialsAPI = {
    // Add more custom endpoints as needed
    getActivePartialsByOrder: () => api.get(`partials/by-order/active/`),
    getArchivePartialsByOrder: (params) => api.get(`partials/by-order/archive/`, { params }),
};

// Add request interceptor to include the token dynamically before each request
api.interceptors.request.use(async (config) => {
    const token = await UserProfile.getToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;  // Include token in Authorization header
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});